
    
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Countries"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"americas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"printableName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"synonyms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ustidPattern"},"arguments":[],"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
